/** Reviewed-item options for PRODUCT-2164 manual verify (matches backend ReviewedItem). */
export const SENTILINK_VERIFY_REVIEWED_ITEMS = [
  { value: "GOVERNMENT_ID", label: "Government-issued photo ID" },
  { value: "SSA_DOCUMENT", label: "Social Security card / SSA document" },
  {
    value: "PROOF_OF_ADDRESS",
    label: "Proof of address (utility bill, lease, bank statement)",
  },
  {
    value: "DIRECT_VERIFICATION",
    label: "Direct verification with applicant (call / video)",
  },
  {
    value: "THIRD_PARTY_VERIFICATION",
    label: "Employer or third-party verification",
  },
  { value: "OTHER", label: "Other" },
] as const;

export type SentilinkVerifyReviewedItemValue =
  (typeof SENTILINK_VERIFY_REVIEWED_ITEMS)[number]["value"];

export function getSentilinkVerifyReviewedItemLabel(
  value: string | null | undefined
): string | null {
  if (!value) {
    return null;
  }
  const match = SENTILINK_VERIFY_REVIEWED_ITEMS.find(
    (item) => item.value === value
  );
  return match?.label ?? null;
}
